var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "inquirycenter" }, [
    _c("p", { staticClass: "directory" }, [
      _c(
        "span",
        {
          staticClass: "directory_home",
          on: { click: _vm.businesspersonalClick },
        },
        [_vm._v("个人中心\n    ")]
      ),
      _vm._v("\n    > 询盘中心\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inquirycenter_main" }, [
      _vm.isPc
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticClass: "eltable",
                  staticStyle: { width: "100%", margin: "20px 0" },
                  attrs: {
                    data: _vm.tableList,
                    border: "",
                    "header-cell-style": _vm.headStyle,
                    "cell-style": _vm.headStyle,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "编号", width: "60" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "状态", width: "90" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.status == 0
                                        ? "审核中"
                                        : scope.row.status == 1
                                        ? "通过"
                                        : "未通过"
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      227792501
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "电话", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "email", label: "邮箱", width: "170" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "message", label: "备注", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "commodityId",
                      label: "商品id",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "购买数量",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "commodityName",
                      label: "商品名称",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "commodityTitle",
                      label: "商品副名称",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      label: "商品分类",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "specifications",
                      label: "商品规格",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "image", label: "图片", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("img", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: {
                                  alt: "图片",
                                  src: _vm.$baseUrl + scope.row.image,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.previewPic(scope.row.image)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1598079734
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "originalPrice",
                      label: "原价",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "presentPrice",
                      label: "现价",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看订单")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.status == 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.examine(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("审核")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2148355206
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-pagination", {
                    attrs: {
                      align: "center",
                      background: "",
                      "current-page": _vm.form.pageNum,
                      "page-size": _vm.form.pageSize,
                      layout: "total, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: { "current-change": _vm.handleCurrentChange },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisible,
                    modal: false,
                    title: "图片预览",
                    width: "50%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      alt: "图片",
                      src: _vm.dialogVisibleUrl,
                      width: "100%",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "修改订单状态",
                    visible: _vm.updateOrderVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.updateOrderVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("span", { staticStyle: { "margin-right": "20px" } }, [
                        _vm._v("状态"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.OrderRadio,
                            callback: function ($$v) {
                              _vm.OrderRadio = $$v
                            },
                            expression: "OrderRadio",
                          },
                        },
                        [
                          _vm.OrderInfo.status == 0
                            ? _c("el-radio", {
                                attrs: { label: "已支付", value: "1" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.OrderInfo.status == 1
                            ? _c("el-radio", {
                                attrs: { label: "已发货", value: "2" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.OrderInfo.status == 2
                            ? _c("el-radio", {
                                attrs: { label: "已完成", value: "3" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "text-align": "end" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.orderFun(_vm.OrderRadio)
                                },
                              },
                            },
                            [_vm._v("确定")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "询盘订单",
                    visible: _vm.orderVisible,
                    width: "80%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.orderVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.orderList,
                        "header-cell-style": _vm.headStyle,
                        "cell-style": _vm.headStyle,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "id", label: "ID", width: "120" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "commodityName",
                          label: "商品名称",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "specifications",
                          label: "商品规格",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "订单状态" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.status == 0
                                          ? "未支付"
                                          : scope.row.status == 1
                                          ? "已支付"
                                          : scope.row.status == 2
                                          ? "已发货"
                                          : "已完成"
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4055636246
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "unitPrice",
                          label: "单价",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "quantity",
                          label: "购买数量",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "businessEmail",
                          label: "回件商家邮箱",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalPrice",
                          label: "总价",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "collectionType",
                          label: "收款方式",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.collectionType == 1
                                          ? "二维码"
                                          : "银行卡"
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          385249438
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "collectionQrcode",
                          label: "收款码地址",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("img", {
                                    staticClass: "collectionQrcode_img",
                                    attrs: {
                                      alt: "图片",
                                      src: scope.row.collectionQrcode,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1565646978
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "beneficiaryName",
                          label: "受益人姓名",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "beneficiaryAddress",
                          label: "受益人地址",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "beneficiaryAccNo",
                          label: "受益人账号",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "addressOfBank",
                          label: "银行地址",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "swiftCode",
                          label: "SWIFT码",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "postCode",
                          label: "邮政编码",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "tel", label: "电话", width: "120" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "customDefinition",
                          label: "自定义字段",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { fixed: "right", label: "操作", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status != 3
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateOrder(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("修改")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1568924529
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  staticClass: "shenhe",
                  attrs: { title: "审核", visible: _vm.examineVisible },
                  on: {
                    "update:visible": function ($event) {
                      _vm.examineVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { title: "审核信息" } },
                    [
                      _c("el-descriptions-item", { attrs: { label: "编号" } }, [
                        _vm._v(_vm._s(_vm.examineList.id)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "创建时间" } },
                        [_vm._v(_vm._s(_vm.examineList.createTime))]
                      ),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.examineList.status == 0
                              ? "审核中"
                              : _vm.examineList.status == 1
                              ? "通过"
                              : "未通过"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "电话" } }, [
                        _vm._v(_vm._s(_vm.examineList.phone)),
                      ]),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "邮箱" } }, [
                        _vm._v(_vm._s(_vm.examineList.email)),
                      ]),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "备注" } }, [
                        _vm._v(_vm._s(_vm.examineList.message)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "商品id" } },
                        [_vm._v(_vm._s(_vm.examineList.commodityId))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "购买数量" } },
                        [_vm._v(_vm._s(_vm.examineList.quantity))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "商品名称" } },
                        [_vm._v(_vm._s(_vm.examineList.commodityName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "商品副名称" } },
                        [_vm._v(_vm._s(_vm.examineList.commodityTitle))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "商品分类" } },
                        [_vm._v(_vm._s(_vm.examineList.categoryName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "商品规格" } },
                        [_vm._v(_vm._s(_vm.examineList.specifications))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "图片" } },
                        [
                          [
                            _c("img", {
                              staticStyle: { width: "50px", height: "50px" },
                              attrs: {
                                alt: "图片",
                                src: _vm.$baseUrl + _vm.examineList.image,
                              },
                            }),
                          ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "原价" } }, [
                        _vm._v(_vm._s(_vm.examineList.originalPrice)),
                      ]),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "现价" } }, [
                        _vm._v(_vm._s(_vm.examineList.presentPrice)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { attrs: { model: _vm.formList } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择状态" },
                              model: {
                                value: _vm.formList.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formList, "status", $$v)
                                },
                                expression: "formList.status",
                              },
                            },
                            _vm._l(_vm.exmineStatus, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formList.status == 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "收件人邮箱" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入收件人邮箱" },
                                    model: {
                                      value: _vm.formList.toUser,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formList, "toUser", $$v)
                                      },
                                      expression: "formList.toUser",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "titel" }, [
                                    _vm._v("(此处可修改询盘用户正确邮箱)"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "商品名称" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入商品名称" },
                                    model: {
                                      value: _vm.formList.commodityName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formList,
                                          "commodityName",
                                          $$v
                                        )
                                      },
                                      expression: "formList.commodityName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "商品规格" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入商品规格" },
                                    model: {
                                      value: _vm.formList.specifications,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formList,
                                          "specifications",
                                          $$v
                                        )
                                      },
                                      expression: "formList.specifications",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "单价" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入单价" },
                                    model: {
                                      value: _vm.formList.unitPrice,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formList, "unitPrice", $$v)
                                      },
                                      expression: "formList.unitPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "购买数量" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入购买数量" },
                                    model: {
                                      value: _vm.formList.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formList, "quantity", $$v)
                                      },
                                      expression: "formList.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "回件商家邮箱" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入回件商家邮箱",
                                    },
                                    model: {
                                      value: _vm.formList.businessEmail,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formList,
                                          "businessEmail",
                                          $$v
                                        )
                                      },
                                      expression: "formList.businessEmail",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { display: "flex" },
                                  attrs: { label: "总价" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入总价" },
                                    model: {
                                      value: _vm.formList.totalPrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formList,
                                          "totalPrice",
                                          $$v
                                        )
                                      },
                                      expression: "formList.totalPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "收款方式" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formList.collectionType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formList,
                                            "collectionType",
                                            $$v
                                          )
                                        },
                                        expression: "formList.collectionType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [_vm._v("二维码")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "2" } },
                                        [_vm._v("银行卡")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.formList.collectionType == 1
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "收款码地址" } },
                                        [
                                          _c(
                                            "el-upload",
                                            {
                                              attrs: {
                                                action:
                                                  this.$baseUrl +
                                                  "/other/upload",
                                                "before-upload":
                                                  _vm.handleBeforeUpload,
                                                "list-type": "picture-card",
                                                "on-preview":
                                                  _vm.handlePictureCardPreview,
                                                "on-remove": _vm.handleRemove,
                                                "on-exceed": _vm.hadleExceed,
                                                "on-success": _vm.handelSuccess,
                                                limit: 1,
                                                name: "file",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-plus",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-dialog",
                                            {
                                              attrs: {
                                                visible: _vm.exmineImageVisible,
                                              },
                                              on: {
                                                "update:visible": function (
                                                  $event
                                                ) {
                                                  _vm.exmineImageVisible =
                                                    $event
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  alt: "图片",
                                                  width: "100%",
                                                  src: _vm.exmineImageImageUrl,
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formList.collectionType == 2
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "受益人姓名" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入受益人姓名",
                                            },
                                            model: {
                                              value:
                                                _vm.formList.beneficiaryName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "beneficiaryName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formList.beneficiaryName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "受益人地址" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入受益人地址",
                                            },
                                            model: {
                                              value:
                                                _vm.formList.beneficiaryAddress,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "beneficiaryAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formList.beneficiaryAddress",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "受益人账号" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入受益人账号",
                                            },
                                            model: {
                                              value:
                                                _vm.formList.beneficiaryAccNo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "beneficiaryAccNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formList.beneficiaryAccNo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "银行地址" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入银行地址",
                                            },
                                            model: {
                                              value: _vm.formList.addressOfBank,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "addressOfBank",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formList.addressOfBank",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "SWIFT码" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入SWIFT码",
                                            },
                                            model: {
                                              value: _vm.formList.swiftCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "swiftCode",
                                                  $$v
                                                )
                                              },
                                              expression: "formList.swiftCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "邮政编码" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入邮政编码",
                                            },
                                            model: {
                                              value: _vm.formList.postCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "postCode",
                                                  $$v
                                                )
                                              },
                                              expression: "formList.postCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "受益人银行" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入受益人银行",
                                            },
                                            model: {
                                              value:
                                                _vm.formList.beneficiaryBank,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "beneficiaryBank",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formList.beneficiaryBank",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "电话" },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入电话",
                                            },
                                            model: {
                                              value: _vm.formList.tel,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formList,
                                                  "tel",
                                                  $$v
                                                )
                                              },
                                              expression: "formList.tel",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { display: "flex" },
                                          attrs: { label: "自定义字段" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "600px",
                                                border: "1px solid #ccc",
                                              },
                                            },
                                            [
                                              _c(
                                                "client-only",
                                                [
                                                  _c("Toolbar", {
                                                    staticStyle: {
                                                      "border-bottom":
                                                        "1px solid #ccc",
                                                    },
                                                    attrs: {
                                                      editor: _vm.editor,
                                                      defaultConfig:
                                                        _vm.toolbarConfig,
                                                      mode: _vm.mode,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("Editor", {
                                                    staticStyle: {
                                                      height: "500px",
                                                      "overflow-y": "hidden",
                                                    },
                                                    attrs: {
                                                      defaultConfig:
                                                        _vm.editorConfig,
                                                      mode: _vm.mode,
                                                    },
                                                    on: {
                                                      onCreated: _vm.onCreated,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formList
                                                          .customDefinition,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formList,
                                                          "customDefinition",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formList.customDefinition",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitFun(_vm.formList)
                                },
                              },
                            },
                            [_vm._v("提交审核")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "yd_qiquirycenter_main" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "yd_main_top_list" },
                [
                  _vm._l(_vm.tableList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "yd_main_top_list_page" },
                      [
                        _c("div", { staticClass: "product-card" }, [
                          _c("div", { staticClass: "product-price-quantity" }, [
                            _c("span", { staticClass: "quantity" }, [
                              _vm._v("创建时间：" + _vm._s(item.createTime)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "price" }, [
                              _vm._v("编号：" + _vm._s(item.id)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-top-section" }, [
                            _c("div", { staticClass: "product-image" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.$baseUrl + item.image,
                                  alt: "商品图片",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.previewPic(item.image)
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-basic-info" }, [
                              _c("div", { staticClass: "product-name" }, [
                                _vm._v(_vm._s(item.commodityName)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "product-category" }, [
                                _vm._v(
                                  "商品分类：" + _vm._s(item.categoryName)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "product-spec" }, [
                                _vm._v("规格：" + _vm._s(item.specifications)),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-bottom-section" }, [
                            _c(
                              "div",
                              { staticClass: "product-price-quantity" },
                              [
                                _c("span", { staticClass: "quantity" }, [
                                  _vm._v("购买数量：" + _vm._s(item.quantity)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    "现价：¥" +
                                      _vm._s(
                                        item.presentPrice
                                          ? item.presentPrice
                                          : 0
                                      )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-email" }, [
                              _vm._v("邮箱：" + _vm._s(item.email)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-remark" }, [
                              _vm._v("备注：" + _vm._s(item.message)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-footer" }, [
                              _c("div", { staticClass: "product-status" }, [
                                _vm._v(
                                  "\n                  审核状态：" +
                                    _vm._s(
                                      item.status == 0
                                        ? "审核中"
                                        : item.status == 1
                                        ? "通过"
                                        : "未通过"
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              item.status == 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "action-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.ydShenHeShow(item)
                                        },
                                      },
                                    },
                                    [_vm._v("审核")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == 1
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "action-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.ydXpOrderShow(
                                            item?.orderVos
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("查看订单")]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("MobilePagination", {
                        attrs: {
                          "current-page": _vm.form.pageNum,
                          "total-items": _vm.total,
                          "items-per-page": _vm.form.pageSize,
                        },
                        on: { "page-changed": _vm.handleCurrentChange },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c("AuditDialog", {
                attrs: {
                  visible: _vm.auditShowDialog,
                  product: _vm.examineList,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.auditShowDialog = $event
                  },
                  confirm: _vm.ydShenHehandleConfirm,
                },
              }),
              _vm._v(" "),
              _c("InquiryOrderModal", {
                attrs: {
                  visible: _vm.isModalVisible,
                  orderData: _vm.orderList,
                },
                on: {
                  close: function ($event) {
                    _vm.isModalVisible = false
                  },
                },
              }),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "yd_main_top" }, [
      _c("div", { staticClass: "yd_main_top_tital" }, [
        _vm._v("\n          询盘中心\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }